import React from 'react'

function Social() {
  return (
        <div className="home__social">
            <a href="https://www.instagram.com/karim.michelf/" className="home__social-icon" target='_blank'>
            <i class="uil uil-instagram"></i>
            </a>

            <a href="https://www.linkedin.com/in/karim-michel-farag/" className="home__social-icon" target='_blank'>
            <i class='bx bxl-linkedin' ></i>
            </a>

            <a href="https://github.com/KarimFarag0" className="home__social-icon" target='_blank'>
            <i class="uil uil-github-alt"></i>
            </a>



        </div>
  )
}

export default Social